import * as yup from 'yup';

import { getDay100YearsBefore, getDayNYearsBefore } from '@/utils/dates/dates';
import { isSecondCarReactive } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

export const erstfahrzeugSchema = yup.object({
  fahrleistung: yup
    .number()
    .default(0)
    .when({
      is: () => isSecondCarReactive.value,
      then: yup.number().min(100).required(),
    }),
  gesellschaftID: yup
    .number()
    .default(0)
    .when({
      is: () => isSecondCarReactive.value,
      then: yup.number().required().notOneOf([0]),
    }),
  isVonPartner: yup.boolean().default(false),
  nutzungsart: yup.string().default(''),
  nutzerkreis: yup.string().default(''),
  wkz: yup.string().default(''),
  juengsterFahrerGeburtsdatum: yup
    .date()
    .nullable()
    .min(getDay100YearsBefore())
    .max(getDayNYearsBefore(17))
    .default(null)
    .when({ is: () => isSecondCarReactive.value, then: yup.date().required() }),
  sfKlasseKH: yup.string().default(''),
  sfKlasseVK: yup.string().default(''),
});

export type Erstfahrzeug = yup.Asserts<typeof erstfahrzeugSchema>;
